<template>
  <div
    class="w-full flex flex-col items-center justify-center gap-3 py-12 text-center"
    :class="variantClasses[variant]"
    data-testid="empty-state"
  >
    <div
      v-if="icon"
      class="flex items-center justify-center w-16 h-16 rounded-full bg-gray-50"
      data-testid="empty-state-icon"
    >
      <v-icon :icon="icon" size="36" class="text-gray-400" />
    </div>

    <div class="flex flex-col gap-1">
      <p class="text-gray-600 font-medium" data-testid="empty-state-title">{{ title }}</p>
      <p
        v-if="description"
        class="text-sm text-gray-400 max-w-md"
        data-testid="empty-state-description"
      >
        {{ description }}
      </p>
    </div>

    <slot />
  </div>
</template>

<script setup lang="ts">
export type EmptyStateVariant = 'plain' | 'dashed'

withDefaults(
  defineProps<{
    title: string
    description?: string
    icon?: string
    variant?: EmptyStateVariant
  }>(),
  {
    description: undefined,
    icon: undefined,
    variant: 'plain'
  }
)

const variantClasses: Record<EmptyStateVariant, string> = {
  plain: '',
  dashed: 'border-2 border-dashed border-gray-200 rounded-lg bg-gray-50'
}
</script>
